import descriptions from '../components/productDescription.json';
import messages from './products.en.json';

// URLs, identifiers, assets and filter values remain shared with the Russian catalogue.
const sharedFields = new Set(['image', 'img', 'video', 'model', 'url', 'link', 'to', 'nav', 'type', 'key', 'backGround', 'filter', 'tags', 'tag', 'configurator']);

export function translateProductContent(value, key) {
    if (sharedFields.has(key)) return value;
    // Galleries can contain either asset paths or objects with captions.
    if (key === 'images' && Array.isArray(value)) {
        return value.map(item => typeof item === 'string' ? item : translateProductContent(item));
    }
    if (typeof value === 'string') return messages[value] || value;
    if (Array.isArray(value)) return value.map(item => translateProductContent(item));
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([field, item]) => [field, translateProductContent(item, field)]));
    }
    return value;
}

const englishDescriptions = Object.fromEntries(Object.entries(descriptions).map(([name, value]) =>
    [name, translateProductContent(value)]));

export function getProductDescription(name, english) {
    return (english ? englishDescriptions : descriptions)[name];
}
